export default "__VITE_ASSET__8_kY4Plk__"